<rt-mailbox-select
  [header]="'app.shared_mailboxes.email_provider_picker.send_as' | translate"
  [triggerSize]="'small'"
  [control]="control"
  [currentUser]="currentUser!"
  [users]="users"
  [items]="items"
  [showManageCompanyButton]="items.length <= 2"
  [disabled]="disabled"
/>
